import { apiFetch } from "../auth/apiClient";

// Gate-operator (FM / security incharge / guard) client for the Visitor
// Approval console. All routes are bearer-authed; the backend re-checks the
// gate role on every call.
export const gateApi = {
  // Admit a pre-approved visitor by the 6-char OTP (or scanned QR payload).
  verifyEntry: (body, { signal } = {}) =>
    apiFetch("/api/visitors/verify-entry", {
      method: "POST",
      authRequired: true,
      body,
      signal,
    }),

  // Every live pass across the whole community ("expected at the gate").
  expected: ({ signal } = {}) =>
    apiFetch("/api/visitors/expected", {
      method: "GET",
      authRequired: true,
      signal,
    }),

  // Visitor log, optionally filtered by status (comma-separated).
  list: (params = {}, { signal } = {}) => {
    const qs = new URLSearchParams(params).toString();
    return apiFetch(`/api/visitors${qs ? `?${qs}` : ""}`, {
      method: "GET",
      authRequired: true,
      signal,
    });
  },

  // Log a walk-up → PENDING; notifies the villa's residents to approve.
  logWalkup: (body, { signal } = {}) =>
    apiFetch("/api/visitors", {
      method: "POST",
      authRequired: true,
      body,
      signal,
    }),

  // Check an APPROVED visitor in → INSIDE.
  checkIn: (id, { signal } = {}) =>
    apiFetch(`/api/visitors/${id}/check-in`, {
      method: "POST",
      authRequired: true,
      signal,
    }),

  // Check an INSIDE visitor out → EXITED.
  checkOut: (id, { signal } = {}) =>
    apiFetch(`/api/visitors/${id}/check-out`, {
      method: "POST",
      authRequired: true,
      signal,
    }),

  // Supervisor override: admit a PENDING walk-up with a mandatory note.
  override: (id, body, { signal } = {}) =>
    apiFetch(`/api/visitors/${id}/override`, {
      method: "POST",
      authRequired: true,
      body,
      signal,
    }),

  // Confirm a resident's identity from their personal QR/token.
  verifyIdentity: (body, { signal } = {}) =>
    apiFetch("/api/identity/verify", {
      method: "POST",
      authRequired: true,
      body,
      signal,
    }),

  // All villas, for the walk-up villa picker.
  villas: ({ signal } = {}) =>
    apiFetch("/api/villas", { method: "GET", authRequired: true, signal }),

  // Attach a face photo to a visitor (guard only). `file` is a File/Blob.
  uploadPhoto: (id, file) => {
    const form = new FormData();
    form.append("file", file);
    return apiFetch(`/api/visitors/${id}/photo`, {
      method: "POST",
      authRequired: true,
      formData: form,
    });
  },

  // Live domestic-staff presence board (all active staff + inside flag).
  rosterDomesticHelp: ({ signal } = {}) =>
    apiFetch("/api/domestic-staff/gate", {
      method: "GET",
      authRequired: true,
      signal,
    }),

  // Attach a number-plate photo (gate operator). `file` is a File/Blob.
  uploadPlatePhoto: (id, file) => {
    const form = new FormData();
    form.append("file", file);
    return apiFetch(`/api/visitors/${id}/plate-photo`, {
      method: "POST",
      authRequired: true,
      formData: form,
    });
  },
};
